export const SET_USERINFO = (state, userInfo) => {
  state.userInfo = userInfo
}
export const SET_NODES = (state, nodes) => {
  state.nodes = nodes
}
export const SET_NODEID = (state, nodeId) => {
  state.nodeId = nodeId
}
export const SET_DEFAULT_NODE = (state, defaultNode) => {
  state.defaultNode = defaultNode
}
export const SET_INDUSTORY_TYPES = (state, industoryTypes) => {
  state.industoryTypes = industoryTypes
}
export const SET_ORGANIZATIONS = (state, organization) => {
  state.organization = organization
}
export const SET_USERROLES = (state, userRoles) => {
  state.userRoles = userRoles
}
export const SET_LOADED = (state, isLoaded) => {
  state.isLoaded = isLoaded
}

export const SET_API_CLIENT = (state, apiClient) => {
  state.apiClient = apiClient
}

export const SET_DISABLE = (state, isDisable) => {
  state.isDisable = isDisable
}
